/* istanbul ignore file */

import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import moment from 'moment-timezone';
import { selectSessionInformation } from '../../../../redux/slices/sessionSlice';

function SensorsHeader({ handleSettingsClick, startDate }) {
  const { timezone } = useSelector(selectSessionInformation);
  return (
    <>
      <div className="mb-2 px-1">
        <Card style={{
          backgroundColor: '#585858', borderRadius: '10px', color: '#d3d3d3',
        }}
        >
          <Card.Header style={{
            backgroundColor: '#585858', color: '#fff', paddingBottom: '0.5rem', borderRadius: '10px',
          }}
          >
            <Row>
              <Col lg={12} xl={4} className="d-flex ">
                <h4
                  onClick={handleSettingsClick}
                  style={{
                    margin: 0,
                    color: '#fff',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }}
                >
                  Sensors
                  {' '}
                  {' '}
                  <small style={{ fontSize: '0.75rem' }}>
                    {
                          startDate && (
                          <span>
                            Since
                            {' '}
                            {moment.unix(startDate).tz(timezone).format('MMM DD, Y')}
                          </span>
                          )
                      }
                  </small>
                </h4>
              </Col>
            </Row>
          </Card.Header>
        </Card>
      </div>
    </>
  );
}
SensorsHeader.propTypes = {
  handleSettingsClick: PropTypes.func.isRequired,
  startDate: PropTypes.number.isRequired,

};
export default SensorsHeader;
